import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAKMp0MRm7aYwWyyjLge6zCdVNxLUx_Ego",
  authDomain: "dream-hotties.firebaseapp.com",
  projectId: "dream-hotties",
  storageBucket: "dream-hotties.firebasestorage.app",
  messagingSenderId: "1083512973654",
  appId: "1:1083512973654:web:bf76eed87f0a2ee0b80ef7",
  measurementId: "G-X3S05745NS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
